import { AlertMessageType } from "data/context/alert-context";

export function showSuccessAlert(showAlert: (data: AlertMessageType) => void, msg: string) {
  showAlert({
    show: true,
    content: msg,
    color: 'success',
    time: 3000,
  });
}

export function showErrorAlert(showAlert: (data: AlertMessageType) => void, msg: string) {
  showAlert({
    show: true,
    content: msg,
    color: 'danger',
    time: 3000,
  });
}

export function showWaitAlert(showAlert: (data: AlertMessageType) => void, msg: string) {
  showAlert({
    show: true,
    content: msg,
    color: 'warning',
    time: 2000,
  });
}

/** Bloqueios por regra de negócio (400/403/409) são avisos (warning); demais falhas seguem como erro. */
export function showAlertPorStatus(showAlert: (data: AlertMessageType) => void, msg: string, statusCode?: number) {
  const regraDeNegocio = statusCode === 400 || statusCode === 403 || statusCode === 409;
  showAlert({
    show: true,
    content: msg,
    color: regraDeNegocio ? 'warning' : 'danger',
    time: 5000,
  });
}
